/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversation_FrozenInputs */

const en_us2_conversation_frozen = /** @type {(inputs: Conversation_FrozenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This conversation is closed and can no longer be changed.`)
};

const pt_br2_conversation_frozen = /** @type {(inputs: Conversation_FrozenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta conversa está encerrada e não pode mais ser alterada.`)
};

const es_419_conversation_frozen = /** @type {(inputs: Conversation_FrozenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta conversación está cerrada y ya no se puede cambiar.`)
};

const pt_pt2_conversation_frozen = /** @type {(inputs: Conversation_FrozenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta conversa está encerrada e já não pode ser alterada.`)
};

const fr_fr2_conversation_frozen = /** @type {(inputs: Conversation_FrozenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette conversation est close et ne peut plus être modifiée.`)
};

const de_de2_conversation_frozen = /** @type {(inputs: Conversation_FrozenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Unterhaltung ist geschlossen und kann nicht mehr geändert werden.`)
};

const it_it2_conversation_frozen = /** @type {(inputs: Conversation_FrozenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa conversazione è chiusa e non può più essere modificata.`)
};

/**
* | output |
* | --- |
* | "This conversation is closed and can no longer be changed." |
*
* @param {Conversation_FrozenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const conversation_frozen = /** @type {((inputs?: Conversation_FrozenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversation_FrozenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_conversation_frozen(inputs)
	if (locale === "es-419") return es_419_conversation_frozen(inputs)
	if (locale === "pt-PT") return pt_pt2_conversation_frozen(inputs)
	if (locale === "fr-FR") return fr_fr2_conversation_frozen(inputs)
	if (locale === "de-DE") return de_de2_conversation_frozen(inputs)
	if (locale === "it-IT") return it_it2_conversation_frozen(inputs)
	return en_us2_conversation_frozen(inputs)
});
export { conversation_frozen as "conversation.frozen" }